<template>
  <div>
    <van-nav-bar
      title="修改昵称"
      left-text=""
      left-arrow
      @click-left="$router.push('/member/information')"
    />
    <van-form @submit="onSubmit" id="changeNick">
      <van-field
        v-model="nickName"
        name="nickName"
        label="昵称"
        placeholder="昵称"
        :rules="[{ required: true, message: '请填写昵称' }]"
      />
      <div style="display: flex; justify-content: center">
        <van-button
          class="change_nick_btn"
          round
          block
          color="#D02E27"
          size="small"
          native-type="submit"
          style="height: 50px"
        >
          确定
        </van-button>
      </div>
    </van-form>


  </div>
</template>

<script>
    export default {
      name: "nickName",
      data(){
        return{
          nickName:''
        }
      },
      methods:{
        isLogin(){
          let that = this;
          if (!that.$store.state.loginType){
            that.$router.push('/login')
          }
        },
        onSubmit(){
          let that = this;
          that
            .$http({
              url: "/",
              method: "post",
              data: {
                nozzle: "modify_name",
                token: sessionStorage.getItem("token"),
                name: that.nickName
              }
            })
            .then(function(res) {
              let resData = res.data;
              if (res.data.code == 1) {
                that.$toast.success({
                  message:resData.msg,
                  onClose:function () {
                    that.$router.push('/member/information')
                  }
                });
              } else if (res.data.code == 0 || res.data.code == -1) {
                that.$toast.fail(resData.msg);
              }
            });
        },
      },
      mounted:function () {
        let that = this;
        that.isLogin();
        if (!that.$store.state.loginType){
          that.$router.push('/login')
        }
      }
    }
</script>

<style scoped>
.change_nick_btn {
  position: fixed;
  bottom: 72px;
  width: 90%;
  margin: 20px;
  font-size: 15px;
}
#changeNick .van-field {
  background-color: #fafafa;
  margin: 20px;
  width: unset;
  border-radius: 10px;
}
</style>
<style>
#changeNick .van-field__label {
  color:#7b7777 !important;
}
#changeNick .van-field__control{
  color:#000000 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/NickName.vue